import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import './styles.css';
import ContestService from "../../services/Contest";

export default function ContestDetail(){
    const [contest, setContest] = useState({});

    const { id } = useParams();

    useEffect(() => {
        ContestService.search(id).then(response => setContest(response))
    }, [id]);

    return(
        <div className="main-detail">

            <div className="item-detail">
                <iframe src={contest.document} title={contest.title}/>
            </div>
            <div className="detail">
                <p className="title-detail">Título:</p>
                <h2 className="item-title-detail">
                    {contest.title}
                </h2>
                <p className="title-detail">Categoria:</p>
                <h2 className="item-title-detail">
                    {contest.category}
                </h2>
                <p className="title-detail">Descrição:</p>
                <p className="description-item-detail">
                    {contest.description}
                    <br/>
                    <br/>
                    <a className='contestDetailA' target='blank' href={contest.document}>Abrir documento em outra aba</a>
                </p>
            </div>
        </div>
    );
}
